import { supabase } from "@/integrations/supabase/client";

export interface CommentBatch {
  id: string;
  video_content_id: string;
  user_id: string;
  video_version: number | null;
  sent_at: string;
  created_at: string;
}

export interface CommentBatchInsert {
  video_content_id: string;
  user_id: string;
  video_version?: number;
}

export const createCommentBatch = async (batch: CommentBatchInsert) => {
  try {
    const { data, error } = await supabase
      .from("video_comment_batch")
      .insert(batch)
      .select()
      .single();

    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    console.error("Error creating comment batch:", error);
    return { success: false, error };
  }
};

export const getBatchesByVideo = async (videoContentId: string) => {
  try {
    const { data, error } = await supabase
      .from("video_comment_batch")
      .select("*")
      .eq("video_content_id", videoContentId)
      .order("sent_at", { ascending: false });

    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    console.error("Error fetching comment batches:", error);
    return { success: false, error };
  }
};
